import { TransportationTypeIcon } from '@/components/icons/TransportationTypeIcon';
import type { LegDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import { Badge, Icons, Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

interface TransportBadgeTriggerProps {
  leg: LegDTO;
  refundedLike: boolean;
  isDetailed?: boolean;
}

const TransportBadgeTrigger: FC<TransportBadgeTriggerProps> = ({
  leg,
  refundedLike,
  isDetailed,
}) => {
  return (
    <Badge
      variant={refundedLike ? 'disabled' : 'light'}
      className={cn('rounded-sm', { 'group cursor-pointer': isDetailed })}
    >
      <TransportationTypeIcon ptMode={leg.ptMode} />
      <Typography variant="body2-bold">{leg.lineNumber}</Typography>
      {isDetailed && (
        <Icons.chevronDown
          height={16}
          width={16}
          className="transition-transform duration-200 group-aria-expanded:rotate-180"
        />
      )}
    </Badge>
  );
};

export default TransportBadgeTrigger;
